import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { saveScheduleService } from '@/modules/order/services/save-schedule.service'
import type { Entity } from '@/modules/shared/types/entity.type'

import { updateScheduleService } from '../services/update-schedule.service'
import {
  useScheduleFormStore,
  useScheduleFormStoreActions,
} from '../stores/schedule-form.store'
import type { ScheduleFormData } from '../types/schedule-form-data.type'

export function useScheduleForm() {
  const [isSavingSchedule, setIsSavingSchedule] = useState(false)
  const { selectedSchedule } = useScheduleFormStore()

  const navigate = useNavigate()

  const { id } = useParams()
  const form = useForm<ScheduleFormData>({
    defaultValues: {
      data: id ? dayjs(selectedSchedule?.data).toDate() : dayjs().toDate(),
    },
  })
  const { setCustomers, setIsOpenModalCustomer, setSelectedSchedule } =
    useScheduleFormStoreActions()

  const handleGoBack = () => {
    navigate('/agendamentos')
    form.reset({
      data: dayjs().toDate(),
      fkCliente: undefined,
      fkUsuarioCel: undefined,
      idAgendamento: undefined,
      observacao: undefined,
    })
    setSelectedSchedule(null)
  }

  const handleSubmitSchedule = async (data: ScheduleFormData) => {
    setIsSavingSchedule(true)
    try {
      if (data.idAgendamento) {
        await updateScheduleService(data)
      } else {
        await saveScheduleService({
          ...data,
        })
      }
      form.reset()
      navigate('/agendamentos')
    } catch (error) {
      toast.error('Erro ao salvar agendamento')
    } finally {
      setIsSavingSchedule(false)
    }
  }

  const handleSelectClient = async (entity: Entity) => {
    form.setValue('fkCliente', entity.idEntidade)

    setSelectedSchedule({
      ...selectedSchedule,
      cliente: entity.razaoSocialNome,
    })

    setIsOpenModalCustomer(false)
    setCustomers([])
  }

  useEffect(() => {
    if (id) {
      form.setValue('data', dayjs(selectedSchedule?.data).toDate())
      form.setValue('observacao', selectedSchedule?.observacao)
      form.setValue('fkCliente', selectedSchedule?.fkCliente)
      form.setValue('fkUsuarioCel', selectedSchedule?.fkUsuarioCel)
      form.setValue('idAgendamento', selectedSchedule?.idAgendamento)
    } else {
      setSelectedSchedule(null)
    }
  }, [])

  return {
    form,
    handleSubmitSchedule,
    handleSelectClient,
    selectedSchedule,
    isSavingSchedule,
    handleGoBack,
  }
}
